module.exports = __webpack_public_path__ + "static/media/digitalization.86d401db.svg";